export const DEFAULT_TIME = "12:00:00";

export function getNumberOfDays(start: Date, end: Date): number {
	const date1 = new Date(start);
	const date2 = new Date(end);
	const oneDay = 1000 * 60 * 60 * 24;
	const diffInTime = date2.getTime() - date1.getTime();
	return Math.round(diffInTime / oneDay);
}

export function isTodayOrBefore(value: string): boolean {
	const tomorrow = new Date();
	tomorrow.setDate(tomorrow.getDate() + 1);
	tomorrow.setHours(0);
	tomorrow.setMinutes(0);
	tomorrow.setSeconds(0);
	tomorrow.setMilliseconds(0);
	return isBefore(value, tomorrow.toISOString());
}

export function isBefore(value: string, max: string): boolean {
	const dA = new Date(value);
	const dB = new Date(max);

	// compare years
	if (dA.getFullYear() < dB.getFullYear()) {
		return true;
	}
	if (dA.getFullYear() > dB.getFullYear()) {
		return false;
	}

	// compare months
	if (dA.getMonth() < dB.getMonth()) {
		return true;
	}
	if (dA.getMonth() > dB.getMonth()) {
		return false;
	}

	// compare days
	if (dA.getDate() < dB.getDate()) {
		return true;
	}
	if (dA.getDate() > dB.getDate()) {
		return false;
	}

	// compare hours
	if (dA.getHours() < dB.getHours()) {
		return true;
	}
	if (dA.getHours() > dB.getHours()) {
		return false;
	}

	// compare minutes
	if (dA.getMinutes() < dB.getMinutes()) {
		return true;
	}
	if (dA.getMinutes() > dB.getMinutes()) {
		return false;
	}

	// compare seconds
	if (dA.getSeconds() < dB.getSeconds()) {
		return true;
	}
	if (dA.getSeconds() > dB.getSeconds()) {
		return false;
	}

	// compare milliseconds
	if (dA.getMilliseconds() < dB.getMilliseconds()) {
		return true;
	}
	if (dA.getMilliseconds() > dB.getMilliseconds()) {
		return false;
	}

	return true;
}

export function getEllapsedTimeInMonths(date1: Date, date2: Date): number {
	if (date1.getTime() >= date2.getTime()) {
		return 0;
	}

	let diff = 0;

	const y1 = date1.getFullYear();
	const y2 = date2.getFullYear();

	const m1 = date1.getMonth();
	const m2 = date2.getMonth();

	const d1 = date1.getDate();
	const d2 = date2.getDate();

	const l1 = new Date(y1, m1 + 1, 0).getDate();
	const l2 = new Date(y2, m2 + 1, 0).getDate();

	if (y1 < y2) {
		diff += d1 / l1;
		diff += 12 * (y2 - y1) - 1;
		if (m1 > m2) {
			diff -= m1 - m2;
		}
		if (m1 < m2) {
			diff += m2 - m1;
		}
		diff += d2 / l2;
	} else if (m1 < m2) {
		diff += d1 / l1;
		diff += m2 - m1 - 1;
		diff += d2 / l2;
	} else if (d1 < d2) {
		diff += (d2 - d1) / l1;
	}

	return diff;
}
export function parseDateTimeValue(value: string | undefined): {
	date: string;
	time: string;
} {
	let date = "";
	let time = "";
	if (value !== undefined) {
		const d = new Date(value);
		date = getDateStr(d);
		time = getTimeStr(d);
	}
	return { date, time };
}

export function formatDateTimeValue(
	date: string,
	time: string
): string | undefined {
	if (date === "" || time === "") {
		return undefined;
	}
	try {
		const dateSlices = date.split("-");
		if (dateSlices.length !== 3) {
			return undefined;
		}

		const timeSlices = time.split(":");
		if (timeSlices.length !== 3) {
			return undefined;
		}

		const d = new Date();

		d.setFullYear(1970);
		d.setDate(1);
		d.setMonth(0);

		d.setHours(0);
		d.setMinutes(0);
		d.setSeconds(0);
		d.setMilliseconds(0);

		d.setFullYear(parseInt(dateSlices[0], 10));
		d.setMonth(parseInt(dateSlices[1], 10) - 1);
		d.setDate(parseInt(dateSlices[2], 10));

		d.setHours(parseInt(timeSlices[0], 10));
		d.setMinutes(parseInt(timeSlices[1], 10));
		d.setSeconds(parseInt(timeSlices[2], 10));
		d.setMilliseconds(0);

		return d.toISOString();
	} catch {
		return undefined;
	}
}

export function getDateStr(d: Date): string {
	return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function getTimeStr(d: Date): string {
	return `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

function pad(v: number): string {
	return `${v < 10 ? "0" : ""}${v}`;
}
